"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadButton = void 0;
var filesize_1 = __importDefault(require("filesize"));
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./DownloadButton.scss");
var utils_1 = require("@app/shared/utils");
var DownloadButton = function (props) {
    var encryptedMsg = props.pkg.encrypted ? "Encrypted packages cannot be downloaded without the Aspera Connect plugin enabled." : '';
    var exceededDSLMsg = (props.maxDownloadSizeInMB && props.pkg.totalBytes > utils_1.megabytesToBytes(props.maxDownloadSizeInMB)) ?
        "Downloads limited to files under " + (filesize_1.default(utils_1.megabytesToBytes(props.maxDownloadSizeInMB)) || filesize_1.default(0, { exponent: 2 })) + " Toggle \"Enable Aspera\" to continue" : '';
    var hasBothMsgs = encryptedMsg && exceededDSLMsg ? '\n' : '';
    var exceedsDownloadLimit = (props.maxDownloadSizeInMB && !props.pkgExpired) ? (props.pkg.totalBytes >= utils_1.megabytesToBytes(props.maxDownloadSizeInMB) || props.pkg.encrypted) : false;
    var downloadIcon = exceedsDownloadLimit ? 'fa-exclamation-triangle' : 'fa-cloud-download-alt';
    var tooltip = exceedsDownloadLimit ?
        "" + encryptedMsg + hasBothMsgs + exceededDSLMsg
        : props.pkgExpired ? 'Expired' : undefined;
    var handleDownload = function (e) {
        e.stopPropagation();
        if (!exceedsDownloadLimit && !props.pkgExpired) {
            props.onDownload();
        }
    };
    return (react_1.default.createElement("div", { className: classnames_1.default({ tooltip: tooltip }, { 'is-tooltip-right': tooltip }, { 'limited-download': exceedsDownloadLimit }, { prewrap: hasBothMsgs }), style: { lineHeight: '1rem' }, "data-tooltip": tooltip },
        react_1.default.createElement("a", { onClick: handleDownload, className: classnames_1.default('download-button', { disabled: props.disabled || (exceedsDownloadLimit || props.pkgExpired) }) },
            react_1.default.createElement("span", { className: "icon" },
                react_1.default.createElement("i", { className: classnames_1.default('fas', downloadIcon, 'fa-lg') })),
            !props.pkgExpired &&
                react_1.default.createElement("p", null, "Download"))));
};
exports.DownloadButton = DownloadButton;
